import { $fetch } from '@/utils/http'

// 获取微应用列表
export const getApps = () => {
  return $fetch(`/mock/11/qiankun-fuchuan/getApps${process.env.NODE_ENV === 'production' ? '' : '-dev'}`)
  // return $fetch(`/mock/7/qiankun-fuchuan/getApps`)
}
// 获取侧边栏目录
export const getMenus = () => {
  return $fetch(`/mock/11/qiankun-fuchuan/getMenus${process.env.NODE_ENV === 'production' ? '' : '-dev'}`)
  // https://yapi.772431358.xyz/mock/11/qiankun-fuchuan/getMenus
  // return $fetch(`/mock/7/qiankun-fuchuan/getMenus`)
}
